<h1 class="title-sect color-blue-dark font-30 f-31">
  Ajustes en documentos de subsidio y/o afiliación
</h1>
<div class="card shadow-item bg-white mg-btm-60 over-hiden col-xs-12">
  <h3 class="subtitle-sect color-blue-dark font-24 f-32">
    Corrige los documentos con novedades de tus beneficiarios.
  </h3>
    <div class="m-t-50">
        <div class="container">
          <div class="form-section container">
            <div class="container-form">
              <div>
                <div class="info-titular bg-light-blue p-4 rounded-lg shadow-item mb-4">
                  <h2 class="color-blue-dark font-24 mb-2">Información de la solicitud</h2>
                  <p class="color-gray font-16">
                    <strong>Radicado:</strong> {{ data?.code || 'No registrada' }}
                  </p>
                  <p class="color-gray font-16">
                    <strong>Fecha de radicación:</strong> {{ data?.update_at | date:'dd/MM/yyyy h:mm a' }}
                  </p>
                </div>

                <div class="info-titular bg-light-blue p-4 rounded-lg shadow-item mb-4">
                  <h2 class="color-blue-dark font-24 mb-2">Información del titular</h2>
                  <p class="color-gray font-16">
                    <strong>Nombre:</strong> {{ data?.nombreTitular }}
                  </p>
                  <p class="color-gray font-16">
                    <strong>Número de documento:</strong> {{ data?.numberDocument}}
                  </p>
                </div>

                <div class="alert-message mb-4">
                  <p class="alert-text text-warning text-center">
                    ¡Atención! Recuerde que tiene un plazo máximo de 5 días para cargar los documentos solicitados a continuación.
                  </p>
                </div>
                <mat-accordion >
                  <ng-container *ngFor="let key of objectKeys(data?.documentos); let i = index">
                  <mat-expansion-panel *ngIf="panelVisibility[i]">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <strong>Documento:</strong>&nbsp;{{ data?.documentos[key].numero_identidad_beneficiario }} 
                        - 
                        &nbsp;<strong>{{ obtenerTipoPersona(key) }}:</strong>&nbsp;{{ obtenerNombreDesdeContrato(data?.documentos[key].contrato_complementos) }}
                      </mat-panel-title>
                      
                    </mat-expansion-panel-header>
                    <div class="row mt-masive" *ngIf="loadingTop">
                      <div class="col-md-12 text-center">
                        <div class="spinner-two spinner-two-blue"></div>
                      </div>
                    </div>

                    <table aria-label="Tabla de histórico de afiliaciones" class="rwd-table" width="100%" cellpadding="0" cellspacing="0" id="tableAffiliation">
                      <thead class="thead">
                        <th  scope = "col" class="text-gray-category color-gray">
                          Tipo complemento
                        </th>
                        <th  scope = "col" class="text-gray-category color-gray">
                          Nombre/archivo
                        </th>
                    
                        <th  scope = "col" class="text-gray-category color-gray">
                          Comentario
                        </th>
                    
                        <th  scope = "col" class="text-gray-category color-gray">
                          Fecha revisión
                        </th>
                    
                        <th  scope = "col" class="text-gray-category color-gray">
                          Gestión
                        </th>
                      </thead>

                      <tbody>
                    
                        <tr *ngIf="data?.documentos.length <= 0 && !loadingTop">
                          <td colspan="5" style="text-align: center;">
                            <span class="text-gray-category color-red">No hay documentos recientes</span>
                          </td>
                        </tr>

                        <tr>
                          <td data-th="tipo complemento">
                            <div>
                              {{ data?.documentos[key].tipo_solicitud }}
                            </div>
                          </td>
                        
                          <td data-th="nombre/archivo">
                            <div class="texto-recortado">
                              <a 
                                [href]="getBlobUrl(data?.documentos[key].url)" 
                                target="_blank" 
                                rel="noopener noreferrer"
                              >
                                {{ data?.documentos[key].tipo_documentos_digitales }}
                              </a>
                            </div>
                          </td>
                        
                          <td data-th="comentario">
                            <div>
                              {{ obtenerMensajeObservaciones(data?.documentos[key].observaciones) }}
                            </div>
                          </td>
                        
                          <td data-th="Fecha revision">
                            <div>
                              {{ data?.documentos[key].fecha_revision | date:'dd/MM/yyyy h:mm a' }}
                            </div>
                          </td>
                        
                          <td data-th="Gestión" class="text-gray-category color-gray">
                            <input 
                              type="file" 
                              #fileInput 
                              (change)="onFileSelected($event, data?.documentos[key], key, i)" 
                              accept="application/pdf" 
                              style="display: none;"
                            />
                            
                            <button 
                              *ngIf="!data?.documentos[key].selectedFile" 
                              (click)="fileInput.value = null; fileInput.click()" 
                              class="u-btn u-btn--blue"
                            >
                              Seleccionar Archivo
                            </button>
                          
                            <button 
                              *ngIf="data?.documentos[key]?.selectedFile" 
                              (click)="removeFile(documento, fileInput, key, i)" 
                              class="u-btn u-btn--red u-btn--delete"
                            >
                              Eliminar Archivo
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="col-md-12" style="margin-top: 35px;">
                      <div class="steps-cont_actions d-flex justify-content-center container">
                        <button
                          role="button"
                          appDebounceClick
                          id="Afiliacion_PTEC-afiliar-trabajador-regresar"
                          title="Enviar todos los documentos"
                          (click)="enviarTodosDocumentos(i, key)"  
                          [disabled]="!allDocumentsUploaded[i]"
                          class="u-btn u-btn--blue"
                        >
                          Enviar
                        </button>
                      </div>
                    </div>
                    
                  </mat-expansion-panel>
                </ng-container>
                </mat-accordion>
              </div>
            </div>
            <br />
            
          </div>
  
          <div class="col-md-12">
            <div
              class="steps-cont_actions d-flex justify-content-center container"
            >

              <a
                role="button"
                appDebounceClick
                id="Afiliacion_PTEC-afiliar-trabajador-regresar"
                title="Volver"
                href="javascript:history.back()"
                routerLinkActive="router-link-active"
                class="u-btn u-btn--line r-hide"
                >Volver
              </a>
            </div>
          </div>
        </div>
    </div>
</div>
